module.exports = "/_next/static/images/01951f0deb8a0b1fc8f7975878c3cfa0-hero-desktop.jpg";